import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { Card, CARD_ELEVATION, CARD_PADDING_SIZE } from 'components/Card'
import { Delimiter } from 'components/Delimiter'
import { Flex } from 'components/Layout'
import { LOADER_SIZE } from 'components/Loader'
import NoData from 'components/NoData'
import { Text } from 'components/Typography'
import { WrappedLoader } from 'components/WrappedLoader'
import { useUserAuth } from 'providers/userAuth'
import { COLOR, FONT_SIZE, FONT_WEIGHT, SPACE } from 'Theme'
import { DashboardTestimonial } from './DashboardTestimonial'
import { useExpertTestimonialsQuery } from './hooks'

const StyledCard = styled(Card)`
  min-height: ${rem(200)};
`

export const TestimonialsWidget = () => {
  const { user } = useUserAuth()
  const { testimonials, loading: isLoading } = useExpertTestimonialsQuery(
    user.id
  )
  return (
    <StyledCard
      flexDirection="column"
      width="100%"
      elevation={CARD_ELEVATION.NONE}
      hasBorders
      paddingSize={CARD_PADDING_SIZE.NONE}
    >
      <Flex p={SPACE.PX_30} pb={SPACE.PX_20}>
        <Text
          fontWeight={FONT_WEIGHT.MEDIUM}
          fontSize={FONT_SIZE.PX_20}
          color={COLOR.GRAYSCALE_1}
        >
          Latest reviews
        </Text>
      </Flex>
      <Delimiter />
      <Flex flexDirection="column" height="100%" flex={1}>
        {isLoading ? (
          <WrappedLoader flex={1} loaderSize={LOADER_SIZE.XS} />
        ) : (
          <>
            {testimonials.length === 0 ? (
              <Flex
                alignItems="center"
                flex={1}
                width="100%"
                justifyContent="center"
              >
                <NoData
                  header="No reviews"
                  content="Your latest reviews will appear here."
                />
              </Flex>
            ) : (
              <Flex flexDirection="column" mb={SPACE.PX_60} flex={1}>
                {testimonials.map(
                  ({ id, feedback, clientName, consultationName }) => (
                    <Flex key={id} flexDirection="column">
                      <DashboardTestimonial
                        feedback={feedback}
                        clientName={clientName}
                        consultationName={consultationName}
                      />
                      <Delimiter />
                    </Flex>
                  )
                )}
              </Flex>
            )}
          </>
        )}
      </Flex>
    </StyledCard>
  )
}
